import { api } from "./index";

export async function fetchAccountSummary() {
  const response = await api.get("/account/summary");
  return response.data;
}

export async function submitBusinessProfile(formData) {
  const response = await api.put("/account/business", formData);
  return response.data;
}

export async function cancelBusinessSubmission() {
  const response = await api.delete("/account/business/submission");
  return response.data;
}

export async function downloadBusinessDocument(fileId) {
  const response = await api.get(`/account/business/documents/${fileId}`, {
    responseType: "blob",
  });
  return response;
}

export async function fetchSubscriptions() {
  const response = await api.get("/subscriptions");
  return response.data;
}

export async function fetchBundleSubscription() {
  const response = await api.get("/subscriptions/bundle");
  return response.data;
}

export async function fetchSubscriptionPayments() {
  const response = await api.get("/subscriptions/payments");
  return response.data;
}

export async function fetchBillingInvoices() {
  const response = await api.get("/subscriptions/bundle/invoices");
  return response.data;
}

export async function downloadInvoice(paymentId, lang = "en") {
  const response = await api.get(`/subscriptions/payments/${paymentId}/invoice`, {
    responseType: "blob",
    params: { lang: String(lang || "en").startsWith("ar") ? "ar" : "en" },
  });
  return response;
}

export async function subscribeToApp(availableAppId) {
  const response = await api.post("/subscriptions/subscribe", { availableAppId });
  return response.data;
}

export async function updateTaxDetails(payload) {
  const response = await api.put("/account/business/tax-details", payload);
  return response.data;
}
